/**
 * 入口（index）: サインイン済みならホームへ送る。
 */

function parseRoles(data: unknown): string[] {
  const raw = (data as { clientPrincipal?: { userRoles?: string[] } | { userRoles?: string[] }[] })?.clientPrincipal;
  const one = Array.isArray(raw) ? raw[0] : raw;
  return Array.isArray(one?.userRoles) ? one.userRoles : [];
}

async function main(): Promise<void> {
  try {
    const res = await fetch('/.auth/me', { credentials: 'include' });
    if (!res.ok) return;
    const data: unknown = await res.json();
    const roles = parseRoles(data);
    if (roles.includes('authenticated') || roles.includes('administrator')) {
      window.location.replace('/home.html');
    }
  } catch {
    /* 未ログインのまま */
  }
}

void main();
